<template>
  <div class="box__content">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'box-content'
}
</script>



// WEBPACK FOOTER //
// BoxContent.vue?43616092